import React from "react";
import styles from "./style.module.css";
import List, { Device } from "../../components/list";
import WarningSvg from "../../components/icons/warning";
import { usePlatform } from "../../hooks/usePlatform";

const devices: Device[] = [
  {
    label: "iOS (iPhone, iPad)",
    value: "/instruction?device=ios"
  },
  {
    label: "Android",
    value: "/instruction?device=android"
  },
  {
    label: "Windows",
    value: "/instruction?device=windows"
  },
  {
    label: "macOS",
    value: "/instruction?device=macos"
  }
];

function SelectDevicePage() {
  const { isTelegram } = usePlatform();
  return (
    <div className={styles.selectDevice}>
      <h1 style={{marginTop: isTelegram ? "0px" : "32px"}}>Выберите ваше<br/>устройство</h1>
      <List list={devices}/>
    </div>
  );
}

export default SelectDevicePage;
